<template>
  <div class="section">
    <div class="container">
      <Permissions>
        <h1 class="title">
          {{ $t("platformDashboard") }}
        </h1>
        <PlatformDashboardTabs />
      </Permissions>
    </div>
  </div>
</template>

<script>
import PlatformDashboardTabs from "@/components/PlatformDashboardTabs.vue";
import Permissions from "@/components/Permissions.vue";

export default {
  name: "PlatformDashboard",
  components: {
    PlatformDashboardTabs,
    Permissions,
  },
};
</script>
